import moment from "moment";
import { amountFormat } from "../services/common.service";
import { Button, Empty } from "antd";
import { useTranslation } from "react-i18next";

export default function ScheduledPaymentList({
  dataSource,
  setDetails,
  setVisible,
  hasMoreRecords,
  fetchMoreTransactions,
}) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty
          description={t("pages.payment_history.no_history_found", {
            defaultValue: "No history found",
          })}
        />
      ) : (
        <div>
          <div style={{ cursor: "pointer" }}>
            {dataSource.map((option, idx) => (
              <div
                key={idx}
                onClick={() => {
                  setDetails(option);
                  setVisible(true);
                }}
              >
                <div className="account-row-data mb-2">
                  <div className="list-row-display-item ">
                    <div>
                      <label className="list-item-heading">
                        {" "}
                        {t("pages.pay_bills.consumer_id", {
                          defaultValue: "Consumer ID",
                        })}
                      </label>
                      <div className="list-item-display">
                        {option.consumerId}
                      </div>
                      <div className="list-item-display">
                        {option.billerName || "-"}
                      </div>
                    </div>
                    <div align="right">
                      <div className="account-balance">
                        {amountFormat(option.amount, option?.txnCcy)}
                      </div>
                      <div className="list-item-heading">
                        {option.scheduledDate
                          ? moment(option.scheduledDate).format("DD-MM-YYYY")
                          : "-"}
                      </div>
                      <div className="list-item-heading mt-1">
                        {option.scheduledStatus === "P" ? (
                          <span className="pending-status px-2 py-1">
                            {t("pages.pending_approval.pending", {
                              defaultValue: "PENDING",
                            })}
                          </span>
                        ) : option.scheduledStatus === "FAIL" ? (
                          <span className="fail-error px-2 py-1">
                            {t("pages.pending_approval.fail", {
                              defaultValue: "FAIL",
                            })}
                          </span>
                        ) : option.scheduledStatus === "CANCELLED" ? (
                          <span className="fail-error px-2 py-1">
                            {t("pages.pending_approval.cancelled", {
                              defaultValue: "CANCELLED",
                            })}
                          </span>
                        ) : option.scheduledStatus === "SUCCESS" ? (
                          <span className="success-text px-2 py-1">
                            {option.scheduledStatus}
                          </span>
                        ) : option.scheduledStatus === null ? (
                          "-"
                        ) : (
                          <span className="success-text px-2 py-1">
                            {option.scheduledStatus}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {hasMoreRecords && (
        <div align="center" className="mt-3">
          <Button type="default" onClick={() => fetchMoreTransactions()}>
            {t("buttons.load_more_records_btn", {
              defaultValue: "Load More Records",
            })}
          </Button>
        </div>
      )}
    </>
  );
}
